module.exports = __webpack_public_path__ + "img/Picture19.f9ed28ba.png";